import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import BloqLogo from "@/components/BloqLogo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#fbfcfc] flex flex-col">
      <div className="bloq-container pt-8">
        <BloqLogo size={26} />
      </div>
      <div className="flex-1 flex items-center justify-center bloq-container">
        <div className="text-center max-w-md">
          <p className="bloq-eyebrow mb-3">404</p>
          <h1 className="bloq-display text-5xl sm:text-6xl mb-4">
            That meeting room <span className="bloq-gradient-text">doesn't exist.</span>
          </h1>
          <p className="text-[#4a4a52] text-lg leading-relaxed mb-8">
            The page you're looking for has either ended, been canceled, or never existed in the first place.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="bloq-btn-primary inline-flex items-center justify-center gap-2" data-testid="notfound-home-link">
              <Home className="w-4 h-4" /> Go home
            </Link>
            <Link to="/app" className="bloq-btn-secondary inline-flex items-center justify-center gap-2" data-testid="notfound-app-link">
              <ArrowLeft className="w-4 h-4" /> Back to your workspace
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
